// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"c2e2f244","803":"81450606"}[chunkId] + ".chunk.js";
};